angular.module('cpm').config(($routeProvider) => {
    'use strict';
    $routeProvider
        .when('/account/:accountId/:advertiserId', {
            redirectTo: '/account/:accountId/:advertiserId/campaigns'
        })

        .when('/account/:accountId/:advertiserId/campaigns', {
            templateUrl: 'advertiser/advertiser.html',
            controller: 'AdvertiserCtrl',
            role: 'ADMIN',
            title: 'Campaigns'
        })

        .when('/account/:accountId/:advertiserId/feeds', {
            controller: 'FeedsCtrl',
            templateUrl: 'feed/feeds.html',
            role: 'ADMIN',
            title: 'Feeds'
        })
        
});
